<template>
  <div class="admin-wrokflow-history-activity-detail">
    <div v-if="activityType === 2">
      <strong class="primaryColor">{{ items.oldString }}</strong> برای <strong>{{ items.newString }}</strong> ارسال کرد.
    </div>
    <div v-if="activityType === 0">وضعیت از <strong class="primaryColor">{{ items.oldString }}</strong> به <strong>{{ items.newString }}</strong> تغییر کرد.</div>
    <div v-if="activityType === 3">اولویت از <strong class="primaryColor">{{ items.oldString }}</strong> به <strong>{{ items.newString }}</strong> تغییر کرد.</div>
  </div>
</template>

<script>
export default {
  name: 'admin-wrokflow-history-activity-detail',
  props: {
    items: null,
    activityType: null,
  },
}
</script>

<style scoped lang="scss">
.admin-wrokflow-history-activity-detail {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0px;
  div {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0px;
    strong {
      color: #556be6;
    }
  }
}
</style>
